// extracted by mini-css-extract-plugin
export default {"container":"HoursForMsisdn_container__TaywS","title":"HoursForMsisdn_title__G-BNL"};